<script setup>
import {
  reactive,
  ref,
  markRaw,
  watch,
  computed,
} from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
// import NavigationButton from '@/components/navigation/NavigationButton.vue';
import NavigationLink from '@/components/navigation/NavigationLink.vue';
import { agentVersion } from '@/config/index';
// import useComponentsStore from '@/stores/components';
import useDataStore from '@/stores/data';
import useUserStore from '@/stores/user';
import AppHeader from '@/components/common/AppHeader.vue';
import EmptySection from '@/components/common/EmptySection.vue';

const { setEncryptType } = useDataStore();

const { t, locale } = useI18n();
const language = ref(locale.value);
const route = useRoute();
const { userInfo } = storeToRefs(useUserStore());
const { encryptType } = storeToRefs(useDataStore());
const finance = ref(encryptType.value);
const mode = ref('MC');

watch(encryptType, (value) => {
  finance.value = value;
});

// const {
//   openReservationDialog,
//   openDeliveryResult,
// } = useComponentsStore();
const { changeMessageType } = useDataStore();

watch(language, (value) => {
  locale.value = value;
  localStorage.setItem('locale', value);
  document.querySelector('html').setAttribute('lang', value);
}, { immediate: true });

// const openReserveDialog = () => {
//   event.stopImmediatePropagation();

//   openReservationDialog({
//     activator: event.currentTarget,
//   });
// };

// const openResultDialog = () => {
//   event.stopImmediatePropagation();

//   openDeliveryResult({
//     activator: event.currentTarget,
//   });
// };

const navigationArray = reactive([
  {
    key: 'emma',
    className: 'nav__text1',
    title: 'navigation.message',
    to: {
      path: '/message',
      query: route.query,
    },
    clickEvent: () => {
      document.body.dispatchEvent(new Event('close-mentionList'));
      changeMessageType('SMS');
    },
    components: markRaw(NavigationLink),
    scope: ['2100'],
  },
  {
    key: 'friendtalk',
    className: 'nav__text2',
    title: 'navigation.friendtalk',
    to: {
      path: '/kakao',
      query: route.query,
    },
    clickEvent: () => {
      document.body.dispatchEvent(new Event('close-mentionList'));
      changeMessageType('FRIENDTALK_TEXT');
    },
    components: markRaw(NavigationLink),
    scope: ['2200', '2210'],
  },
  {
    key: 'alimtalk',
    className: 'nav__text3',
    title: 'navigation.alimtalk',
    to: {
      path: '/alimtalk',
      query: route.query,
    },
    clickEvent: () => {
      changeMessageType('ALIMTALK_BA');
      document.body.dispatchEvent(new Event('close-mentionList'));
    },
    components: markRaw(NavigationLink),
    scope: ['2200', '2220'],
  },
  {
    key: 'brand',
    className: 'nav__text6',
    title: 'navigation.brand',
    to: {
      path: '/brand',
      query: route.query,
    },
    clickEvent: () => {
      changeMessageType('');
      document.body.dispatchEvent(new Event('close-mentionList'));
    },
    components: markRaw(NavigationLink),
    scope: ['2200', '2220'],
  },
  // {
  //   key: 'reserve',
  //   className: 'nav__text4',
  //   title: 'common.navigationTypeReserve',
  //   clickEvent: openReserveDialog,
  //   components: markRaw(NavigationButton),
  // },
  // {
  //   key: 'result',
  //   className: 'nav__text5',
  //   title: 'navigation.shippingResult',
  //   clickEvent: openResultDialog,
  //   components: markRaw(NavigationButton),
  // },
]);

const displayList = computed(() => navigationArray.filter(({ scope }) => {
  const useScope = userInfo.value.scope;

  return scope.some((key) => useScope.includes(key));
}));

const financeDisplay = computed(() => {
  const useScope = userInfo.value.scope;

  return useScope.includes('9999');
});

const languageList = reactive([
  {
    label: computed(() => t('navigation.language.korean')),
    value: 'ko',
  },
  {
    label: computed(() => t('navigation.language.english')),
    value: 'en',
  },
]);

const financeList = reactive([
  {
    label: computed(() => t('navigation.finance.default')),
    value: 'NONE',
  },
  {
    label: computed(() => t('navigation.finance.aes256')),
    value: 'AES256',
  },
  {
    label: computed(() => t('navigation.finance.aria256')),
    value: 'ARIA256',
  },
]);

const query = {};
const search = (window.location.search || '').slice(1);

search.split('&').forEach((str) => {
  const [key, value] = str.split('=');

  query[key] = value;
});

if (query?.nonce && query?.organizationId) {
  mode.value = 'CORE';
}

const header = computed(() => {
  const map = {
    MC: AppHeader,
    CORE: EmptySection,
  };

  return map[mode.value] || EmptySection;
});

const noHeaderClass = computed(() => mode.value === 'CORE');

const changeFinance = (value) => {
  setEncryptType(value);
};

</script>
<template>
  <component
    :is="header"
    :is-save-button-visible="true"
  />
  <div
    class="wrap"
    :class="{ 'no-header': noHeaderClass }"
  >
    <div class="navigation-wrap">
      <div class="navigation">
        <strong>{{ t('navigation.mainTitle') }}<br />{{ t('navigation.subTitle') }}</strong>
        <p>Version {{ agentVersion }}</p>
        <nav>
          <component
            v-for="item in displayList"
            :key="`navigation${item.key}`"
            :is="item.components"
            :to="item.to"
            :class-name="item.className"
            :title="item.title"
            :active="true"
            @click-event="item.clickEvent"
          />
          <div
            v-if="financeDisplay"
            class="finance"
          >
            <p>{{ t('navigation.finance.select') }}</p>
            <v-select
              v-model="finance"
              :items="financeList"
              class="font-size-11"
              item-title="label"
              item-value="value"
              :menu-props="{
                contentClass: ['font-size-11'],
                scrim: true,
                scrollStrategy: 'close',
              }"
              @update:modelValue="changeFinance"
            />
          </div>
          <div class="language">
            <p>{{ t('navigation.language.select') }}</p>
            <!-- :label="t('common.languageSelect')" -->
            <v-select
              v-model="language"
              :items="languageList"
              class="font-size-11"
              item-title="label"
              item-value="value"
              :menu-props="{
                contentClass: ['font-size-11'],
                scrim: true,
                scrollStrategy: 'close',
              }"
            ></v-select>
              <!-- menu -->
          </div>
        </nav>
      </div>
    </div>
    <slot />
  </div>
</template>
